module.exports = __webpack_public_path__ + "img/st_icon_list_nor.419da70c.svg";